import { Breakpoints, Layout } from '@volkswagen-onehub/components-core';
import React from 'react';
import {
	ConfirmacionWrapper,
	LastNavigation,
	LegalesFormatoLayer,
	LssiTkmQuestions,
	PoliticaPrivacidad,
} from 'src/components';

export const ConfirmacionProspects = () => {
	return (
		<ConfirmacionWrapper>
			<Layout
				appearance={{
					[Breakpoints.default]: [
						{ name: '.', columns: 2 },
						{ name: 'a', columns: 20 },
						{ name: '.', columns: 2 },
					],
					[Breakpoints.b960]: [
						{ name: '.', columns: 3 },
						{ name: 'a', columns: 18 },
						{ name: '.', columns: 3 },
					],
				}}
				allowOverflowingContent
			>
				<LssiTkmQuestions showTitle={true} />
				<PoliticaPrivacidad />

				<LastNavigation />
				<LegalesFormatoLayer noPadding={false} showTitle={true} />
			</Layout>
		</ConfirmacionWrapper>
	);
};
